import { useRemovePartnerCompany } from '@/hooks/useReceivers';
import { useToast } from '@/hooks/useToast';
import { useCallback } from 'react';
import Modal from '../ui/Modal';
import { useTranslation } from '@/i18n';

interface RemoveReceiverModalProps {
  receiverId: string;
  closeModal: () => void;
}

const RemoveReceiverModal = ({
  receiverId,
  closeModal,
}: RemoveReceiverModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: removePartnerCompany } = useRemovePartnerCompany();
  const { toastAsync } = useToast();

  const removeReceiver = useCallback(
    async () =>
      toastAsync(removePartnerCompany(receiverId), {
        success: t('receivers.success.receiverRemoved'),
      }),
    [receiverId, removePartnerCompany, toastAsync, t],
  );

  return (
    <Modal
      title={t('receivers.modals.removeReceiver.title')}
      message={t('receivers.modals.removeReceiver.message')}
      actionOnClick={removeReceiver}
      actionTitle={t('receivers.modals.removeReceiver.actionTitle')}
      closeModal={closeModal}
      specialColor="error"
    />
  );
};

export default RemoveReceiverModal;
